import React from 'react';
import './LandingButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function LandingButton({
    children,
    variant = 'primary',
    size = 'md',
    icon = null,
    onClick,
    className = '',
    ...props
}) {
    return (
        <button
            className={`ovicatalogos-btn ovicatalogos-btn-${variant} ovicatalogos-btn-${size} ${className}`}
            onClick={onClick}
            {...props}
        >
            {icon && (
                <FontAwesomeIcon
                    icon={icon}
                    className="ovicatalogos-btn-icon"
                />
            )}
            <span className="ovicatalogos-btn-text">{children}</span>
        </button>
    );
}

export default LandingButton;
